const MLETRPATH = "https://academy.iccwbo.org/digital-trade/article/mletr-an-overview-of-uncitrals-model-law-on-electronic-transferable-records";
const IGPNIPATH = "https://docs.tradetrust.io/docs/migration-guide/igp-i"

export { MLETRPATH, IGPNIPATH };